import { SlidersHorizontal, Code2, Sparkles, Maximize, Minimize } from "lucide-react";
import PropertiesPanel from "./PropertiesPanel";
import CodePanel from "./CodePanel";
import AiPanel from "@/components/ai/AiPanel";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useEditor } from "./useEditorState";

const TABS = [["props", "Proprietà", SlidersHorizontal], ["code", "Codice", Code2], ["ai", "AI", Sparkles]];

export default function RightPanel() {
  const { ui, setUi, isDesktop } = useEditor();
  return (
    <div className="h-full flex flex-col bg-white border-l border-slate-200 min-w-0" data-testid="right-panel">
      <div className={`h-11 shrink-0 flex items-stretch border-b ${isDesktop ? "" : "pr-11"}`}>
        {TABS.map(([k, l, Icon]) => (
          <button key={k} onClick={() => setUi({ rightTab: k })} data-testid={`right-tab-${k}`}
            className={`flex-1 inline-flex items-center justify-center gap-1.5 text-xs font-medium border-b-2 transition-colors ${ui.rightTab === k ? "border-sky-600 text-slate-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}>
            <Icon size={14} />{l}
          </button>
        ))}
        {isDesktop && (
          <button onClick={() => setUi({ expanded: !ui.expanded })} className="px-3 text-slate-400 hover:text-slate-800" aria-label="Espandi pannello" data-testid="right-expand-btn">
            {ui.expanded ? <Minimize size={14} /> : <Maximize size={14} />}
          </button>
        )}
      </div>
      <div className="flex-1 min-h-0">
        {ui.rightTab === "props" && <ScrollArea className="h-full"><PropertiesPanel /></ScrollArea>}
        {ui.rightTab === "code" && <CodePanel />}
        {ui.rightTab === "ai" && <AiPanel />}
      </div>
    </div>
  );
}
